<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div style="width:100%">
            <div class="card mt-2">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="alert alert-danger" role="alert">
                      Jika jumlah TRANSAKSI ISOLIR lebih banyak dari jumlah CUTI / ISOLIR, Klik <strong>TIDAK SINGKRON</strong>, lalu batalkan kemudian Pelanggan akan kembali ke BELUM BAYAR
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button @click="notSingkron()" class="btn btn-danger">Tidak Singkron</button>
                    <button v-show="notSingkronStat != null" @click="getData();notSingkronStat = null" class="btn btn-info">Refresh</button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Bulan & Tanggal</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-if="pelanggan == null"><td></td><td>Tidak ada Data</td></tr>
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>                        
                        <td>{{ u.user.unama }}</br>{{ u.user.wa }}</td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>
                          <span class="text-info">{{BulanOnly(u.user.tanggal)}}</span> 
                          <br> 
                          {{ tglIndo(u.user.bayar_tanggal) }}
                        </td>
                        <td>
                            <button @click="cancelIsolirBtn(u.user.uid)" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Batalkan Isolir</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="card-footer " v-show="!isCari">
                <div class="text-center" style="width:100%">
                  <button class="btn btn-info" @click="loadMore()" v-show="pageStat != 999">Load More...</button>
                </div>
              </div>

            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

import moment from 'moment'
Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'Loading': Loading
  },
  data () {
    return {
      loading: true,
      pelanggan: [],
      notSingkronStat: null,

      page: 0,
      pageStat: 0,
    }
  },
  methods: {
    /*
      ADMIN 
    */

    BulanOnly(date) {      
      var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    isNullText(x) {
      var a;
      if (x == null) {
        a = "";
      } else {
        a = x
      }
      return a;
    },
    customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
    },
    startDownload() {

    },
    loadMore() {
      this.page = this.page + 1;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_isolir");
      data.append('page', this.page);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          var data = x.data;
          var i;
          
          for (i = 0; i < data.length; i++) {
            this.pelanggan.push(data[i]);
          }
          //this.pelanggan = x.data;
          this.totalBelum = parseInt(this.totalBelum) + parseInt(x.pesan);

          //this.parseExcel(this.pelanggan, "");

        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    getData() {
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_isolir");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;

        if (x.status) {
          this.pelanggan = x.data;
          //this.totalHistory = x.pesan;

        } else {
          this.pelanggan = null;
        }
      })
    },
    notSingkron() {
      this.notSingkronStat = "click";
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_isolir_nosingkron");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;

        if (x.status) {
          this.pelanggan = x.data;
        } else {
          this.pelanggan = null;
        }
      })
    },
    cancelIsolirBtn(uid) {
        this.cancelProses(uid);
        this.batalkanTransaksi(uid, "0", null);
    },
    cancelProses(uid) {
      this.isCari = false;
      let data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        uid: uid
      }
      
      var apiUrl = inter.CancelIsolir();
      this.PostData(data,apiUrl).then(x => {

        if (x.status) {
          console.log("berhasil")
        } else {
          console.log(x.pesan)
        }
      })
    },
    batalkanTransaksi(id, bulanid, historyid) {
        // id == user id
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', id);
      data.append('bulan', bulanid);
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      if (historyid != null) {
        data.append('hid', historyid);
      }
      
      var apiUrl = inter.postBalikin();
      this.PostData(data,apiUrl).then(x => {

        console.log(JSON.stringify(x));

        if (x.status == "true") {
          console.log("berhasil 2")
          this.getData();
        } else {
          console.log(x.pesan)
        }
      })
    }
  },
  mounted () {
    this.namaQ = sessionStorage.getItem('admin');
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan-lunas/main-isolir.vue